import { createContext, useContext } from "react"

// The URL as the user sees it. During SSR the router reports the rewritten page path (e.g. /app/reports/orders).
export const CurrentPathContext = createContext("/")

export const useCurrentPath = () => useContext(CurrentPathContext)

export const SidebarCollapsedContext = createContext(false)

export const useSidebarCollapsed = () => useContext(SidebarCollapsedContext)
